module.exports = __webpack_public_path__ + "static/media/70.48d249ce.jpg";